export default __webpack_public_path__ + "static/media/bunge.f2fa993b.svg";